export const
    PAGES_PENDING = 'pages_pending',
    PAGES_FAILED = 'pages_failed',
    PAGES_DOWNLOADED = 'pages_downloaded',
    PAGES_RESET = 'pages_reset',
    PAGE_RESET = 'page_reset',
    PAGE_DOWNLOADED = 'page_downloaded',
    PAGE_FAILED = 'page_failed',
    PAGE_DELETING = 'page_deleting',
    PAGE_DELETED = 'page_deleted',
    PAGE_EDITING = 'page_editing',
    PAGE_FOCUS = 'page_focus',
    PAGE_POSTING = 'page_posting',
    PAGE_MEDIA_FOCUS = 'page_media_focus',
    PAGE_MEDIA_UPLOADING = 'page_media_uploading',
    PAGE_MEDIA_FAILED = 'page_media_failed',
    PAGE_MEDIA_UPLOADED = 'page_media_uploaded',
    PAGE_MEDIA_DELETING = 'page_media_deleting',
    PAGE_MEDIA_DELETED = 'page_media_deleted';



// WEBPACK FOOTER //
// src/store/pages/types.js